import { useTranslation } from "react-i18next";
import Faq from "../shared/Faq";
import FeaturesStack from "../shared/FeaturesStack";
import LandingFooter from "../shared/LandingFooter";
import LandingNav, { type NavLink } from "../shared/LandingNav";
import type { LandingData } from "../types";
import HeroA from "./HeroA";
import PaymentTimeline from "./PaymentTimeline";
import PlansA from "./PlansA";
import TypeBand from "./TypeBand";

// Night Studio: cinematic dark landing. Hero letter field, story stack, glass plan picker, payment timeline, type band, FAQ.
export default function LandingA({ data }: { data: LandingData }) {
  const { t } = useTranslation();
  const links: NavLink[] = (["features", "plans", "payment", "faq"] as const).map((k) => ({ href: `#${k}`, label: t(`ui.landing.nav.${k}`) }));
  return (
    <>
      <LandingNav data={data} links={links} heroId="hero-cta" overlay />
      <main>
        <HeroA data={data} />
        <FeaturesStack variant="a" id="features" />
        <PlansA data={data} />
        <PaymentTimeline />
        <TypeBand />
        <Faq variant="accordion" className="py-[clamp(88px,10vw,150px)]" />
      </main>
      <LandingFooter data={data} />
    </>
  );
}
